export const fontSizes = {
  xs: '0.75rem', // 12px
  sm: '0.875rem', // 14px Kula's default font size
  md: '1rem', // 16px
  lg: '1.125rem', // 18px
  xl: '1.25rem', // 20px
  xxl: '1.375rem', // 22px
  xxxl: '1.5rem', // 24px
};
